import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { PLATFORM_BY_KEY } from "../platforms";

// Faithful-ish social feed mockup for a single platform preview.
export function SocialPreviewCard({ preview, index = 0, className }) {
  const meta = PLATFORM_BY_KEY[preview.platform] || {};
  const Icon = meta.Icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: index * 0.06 }}
      className={cn("flex w-full flex-col overflow-hidden rounded-lg border border-border bg-card", className)}
      data-testid={`preview-card-${preview.platform}`}
    >
      {/* Header */}
      <div className="flex items-center gap-2.5 border-b border-border px-4 py-3">
        {Icon && (
          <span className="flex h-8 w-8 items-center justify-center rounded-full border border-border bg-accent/40">
            <Icon size={16} />
          </span>
        )}
        <div className="min-w-0 leading-tight">
          <div className="truncate text-sm font-medium capitalize">{meta.label || preview.platform}</div>
          <div className="promo-overline">Sponsored</div>
        </div>
      </div>

      {/* Image */}
      {preview.image ? (
        <div className="aspect-[4/3] w-full overflow-hidden bg-accent/30">
          <img src={preview.image} alt={preview.title || "product"} className="h-full w-full object-cover" />
        </div>
      ) : (
        <div className="flex aspect-[4/3] w-full items-center justify-center bg-accent/30 text-xs text-muted-foreground">
          No image
        </div>
      )}

      {/* Body — renders the EXACT caption that will be published
          (preview.content == social_posts.content == published caption). */}
      <div className="flex flex-1 flex-col gap-2 px-4 py-3">
        {preview.content ? (
          <p className="whitespace-pre-line text-xs leading-relaxed text-foreground/90"
             data-testid={`preview-caption-${preview.platform}`}>{preview.content}</p>
        ) : (
          <>
            {preview.title && <p className="text-sm font-medium leading-snug">{preview.title}</p>}
            {preview.body && <p className="whitespace-pre-line text-xs leading-relaxed text-foreground/90">{preview.body}</p>}
            {preview.hashtags?.length > 0 && (
              <p className="text-xs font-medium text-brand">{preview.hashtags.join(" ")}</p>
            )}
          </>
        )}
      </div>

      {/* Footer chips */}
      <div className="flex flex-wrap items-center gap-1.5 border-t border-border px-4 py-2.5">
        {preview.provider && (
          <span className="rounded-full bg-accent/50 px-2 py-px text-[10px] font-mono text-muted-foreground">{preview.provider}</span>
        )}
        {preview.prompt_key && (
          <span className="truncate rounded-full bg-accent/50 px-2 py-px text-[10px] font-mono text-muted-foreground" title={preview.prompt_key}>
            {preview.prompt_key}{preview.prompt_version ? ` v${preview.prompt_version}` : ""}
          </span>
        )}
        {preview.knowledge_base && (
          <span className="rounded-full bg-accent/50 px-2 py-px text-[10px] font-mono text-muted-foreground">KB</span>
        )}
      </div>
    </motion.div>
  );
}
